<template>
    <div style="width: 100%; margin-top: var(--spacing-6);">
        <div id="appliance">
            <div style="
                width: 175px;
                height: 175px;
                display: flex;
                align-items: center;
                justify-content: center;
            ">
                <patternlib-image 
                    v-if="pictureSRC"
                    :src="pictureSRC"
                    height="100%"
                    width="100%"
                    object-fit = "scale-down"
                >
                </patternlib-image>

                <patternlib-icon v-if="pictureSRC == ''" icon-name="HOME" size="128px">
                </patternlib-icon>

                <patternlib-spinner v-if="pictureSRC == null" size="sm" spin/>
            </div>

            <div style="width: 100%;">
                <patternlib-headline 
                    :headline="name"
                    heading-tag="h3"
                    separator="none"
                    style="margin-bottom: 10px;"
                ></patternlib-headline>

                <patternlib-list no-separator item-height="30px">
                    <patternlib-list-item>
                        <span>{{ $t("appliance.designation") }}</span>
                        <span slot="value">{{ designation }}</span>
                    </patternlib-list-item>
                    <patternlib-list-item>
                        <span>{{ $t("appliance.serialnumber") }}</span>
                        <span slot="value">{{ serialnumber }}</span>
                    </patternlib-list-item>
                    <patternlib-list-item>
                        <span>{{ $t("appliance.servicenumber") }}</span>
                        <span slot="value">{{ servicenumber }}</span>
                    </patternlib-list-item>
                </patternlib-list>

                <div id="mobileList">
                    <p><b>{{ $t("appliance.designation") }}</b></p>
                    <p style="margin-bottom: var(--spacing-3);">{{ designation }}</p>
                    <p><b>{{ $t("appliance.serialnumber") }}</b></p>
                    <p style="margin-bottom: var(--spacing-3);">{{ serialnumber }}</p>
                    <p><b>{{ $t("appliance.servicenumber") }}</b></p>
                    <p style="margin-bottom: var(--spacing-3);">{{ servicenumber }}</p>
                </div>

                <patternlib-button 
                    v-if = globalStore.showOrders
                    label-text-align="left"
                    icon-position="right"
                    size="small"
                    :label="$t('appliance.findAccesories')"
                    style="margin-right: 20px; margin-top: 20px; margin-bottom: var(--spacing-3);"
                    @click="getAccessoryShopUrl(serialnumber)"
                >
                    <patternlib-icon icon-name="font-arrow" size="24px" slot="icon"></patternlib-icon>
                </patternlib-button>

                <patternlib-button 
                    label-text-align="left"
                    icon-position="right"
                    size="small"
                    type="secondary"
                    :label="$t('appliance.changeNickname')"
                    style="margin-top: 20px; margin-right: 20px; margin-bottom: var(--spacing-3);"
                    @click="$emit('changeNickname', {serialnumber: serialnumber, nickname: name})"
                >
                    <patternlib-icon icon-name="edit" size="24px" slot="icon"></patternlib-icon>
                </patternlib-button>

                <patternlib-button 
                    label-text-align="left"
                    icon-position="right"
                    size="small"
                    type="secondary"
                    :label="$t('appliance.delete')"
                    style="margin-top: 20px; margin-bottom: var(--spacing-3);"
                    @click="$emit('deleteAppliance', {serialnumber: serialnumber, nickname: name})"
                >
                    <patternlib-icon icon-name="bin" size="24px" slot="icon"></patternlib-icon>
                </patternlib-button>
            </div>
        </div>
        <div
            style="
                width: 100%;
                height: 0px;
                margin-top: var(--spacing-5);
                border-bottom-width: 1px;
                border-bottom-color: var(--color-steel-400);
            "
        ></div>
    </div>
</template>

<script>
import { useGlobal } from "../stores/globalStore"

export default {
  props: ["name", "designation", "serialnumber", "servicenumber", "pictureSRC", "deleteApplianceCallback"],
  data: () => ({
  }),

  components: {
  },

  methods: {
    getAccessoryShopUrl(serialnumber) {
        window.location.href = `${this.globalStore.accessoryShopUrl}?number=${serialnumber}`;
    }
  },

  computed: {
    globalStore: () => useGlobal()
  }
};
</script>

<style lang="scss" scoped>
#appliance {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;
}

#mobileList {
    display: none;
}

@media only screen and (max-width: 770px) {
    #appliance {
        flex-direction: column;
    }

    patternlib-list {
        display: none;
    }

    #mobileList {
        display: block;
    }

    patternlib-button {
        display: block !important;
        width: 100%;
    }
}
</style>